import React from "react"
import { Grid, useTheme } from "@material-ui/core"
import { MemberName } from "./MemberName"
import { About } from "./About"
import Social from "./Social"
import useMediaQuery from "@material-ui/core/useMediaQuery"

export default function MemberDetails({
                                        name,
                                        about,
                                        socialHandles,
                                      }) {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <Grid container spacing={4} direction={"column"} alignItems={matches ? "center" : "flex-start"}>
      <Grid item xs={12}>
        <MemberName name={name}/>
      </Grid>
      <Grid item xs={12}>
        <About value={about}/>
      </Grid>
      <Grid item xs={12}>
        <Social items={socialHandles}/>
      </Grid>
    </Grid>
  )
}
